<template>
  <v-card class="com-pc-card rw-txt">
    <v-col class="com-pc-card-header rw-header">
      <span class="com-pc-card-title">発表文</span>
    </v-col>
    <v-col class="white box-link">
      <v-row v-if="selectedRwDetailRw" class="pl-4 pr-2">
        <span class="rw-span-text" v-text="selectedRwDetailRw.text"></span>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "rw-txt",
  computed: {
    /**
     * 選択中河川予警報詳細
     */
    selectedRwDetailRw: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rw[
          this.$store.state.RiverWarn.selectedAnnIdx
        ];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.rw-txt {
  width: 100%;

  .rw-header {
    display: flex;
    align-items: center;
  }

  .rw-span-text {
    white-space: pre-wrap;
    width: 100%;
  }

  .rw-pdf-head {
    justify-content: flex-end;
    align-items: center;
    border-bottom: solid lightgray 1px;
  }
}
</style>
